import {mount} from 'svelte';

import * as Utils from '@js/modules/utils';
import {videoLazyLoader} from '@js/modules/videoLazyLoader';
import AnimateElement from '@js/modules/animateElement';
import Testimonials from '@js/modules/testimonials';

const CollaborativeMap = () => import('@js/components/maps/CollaborativeMap.svelte');
const CollaborativeRouteDetails = () => import('@js/components/collaborative/CollaborativeRouteDetails.svelte');
const CollaborativeRouteInfo = () => import('@js/components/collaborative/CollaborativeRouteInfo.svelte');
const CollaborativeCreationForm = () => import('@js/components/collaborative/CollaborativeCreationForm.svelte');
const CollaborativeGroupHeader = () => import('@js/components/collaborative/CollaborativeGroupHeader.svelte');
const CollaborativeRouteComparison = () => import('@js/components/collaborative/CollaborativeRouteComparison.svelte');
const CollaborativeDates = () => import('@js/components/collaborative/CollaborativeDates.svelte');

class CollaborativeNewManager {
    _$groupData = document.getElementById('collaborative-group-data');
    _$existingRideData = document.getElementById('collaborative-existing-ride-data');
    _$existingRideTracks = document.getElementById('collaborative-existing-ride-tracks');

    _model = {
        group: null,
        existingRide: null,
        existingRideTracks: null,
        mapId: 'collaborative-creation-map'
    };

    _components = {
        $map: document.getElementById('collaborative-creation-map'),
        $routeDetails: document.getElementById('collaborative-route-details'),
        $routeInfo: document.getElementById('collaborative-route-info'),
        $form: document.getElementById('collaborative-creation-form'),
        $groupHeader: document.getElementById('collaborative-group-header'),
        $routeComparison: document.getElementById('collaborative-route-comparison'),
        $dates: document.getElementById('collaborative-dates')
    };

    constructor() {
        if (this._$groupData) {
            this._model.group = JSON.parse(this._$groupData.innerText)?.group;
        }

        if (this._$existingRideData) {
            this._model.existingRide = JSON.parse(this._$existingRideData.innerText)?.ride;
        }

        if (this._$existingRideTracks) {
            this._model.existingRideTracks = JSON.parse(this._$existingRideTracks.innerText);
        }
    }

    initialize = () => {
        Utils.onPageReady(() => {
            if (this._model.group && this._components.$groupHeader) {
                CollaborativeGroupHeader().then(({default: Component}) => {
                    mount(Component, {
                        target: this._components.$groupHeader,
                        props: {
                            group: this._model.group
                        }
                    });
                });
            }

            CollaborativeMap().then(({default: Component}) => {
                mount(Component, {
                    target: this._components.$map,
                    props: {
                        mapId: this._model.mapId,
                        group: this._model.group,
                        existingRide: this._model.existingRide,
                        initialMapPoints: this._model.existingRideTracks,
                        legendEditable: true
                    }
                });

                this._components.$map.classList.remove('collaborative-creation-map-preload');
            });

            setTimeout(() => {
                if (this._model.group && this._components.$routeComparison) {
                    CollaborativeRouteComparison().then(({default: Component}) => {
                        mount(Component, {
                            target: this._components.$routeComparison,
                            props: {}
                        });
                    });
                }

                if (this._model.group && this._components.$dates) {
                    CollaborativeDates().then(({default: Component}) => {
                        mount(Component, {
                            target: this._components.$dates,
                            props: {
                                group: this._model.group
                            }
                        });
                    });
                }

                CollaborativeRouteDetails().then(({default: Component}) => {
                    mount(Component, {
                        target: this._components.$routeDetails,
                        props: {}
                    });
                });

                CollaborativeRouteInfo().then(({default: Component}) => {
                    mount(Component, {
                        target: this._components.$routeInfo,
                        props: {}
                    });
                });
            }, 800);

            setTimeout(() => {
                CollaborativeCreationForm().then(({default: Component}) => {
                    mount(Component, {
                        target: this._components.$form,
                        props: {
                            group: this._model.group,
                            existingRide: this._model.existingRide
                        }
                    });
                });
            }, 1000);

            AnimateElement.initialize();

            videoLazyLoader();

            Testimonials.initialize();
        });
    };
}

export default new CollaborativeNewManager();
